<ng-template let-item let-index="index" let-first="first" let-last="last" #creditCardStmtTmplt
  [appControlTemplate]="'creditCardStmtTmplt'">

  <box class="credit-card-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="item.merchantId; else noPhoto">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container>
      <ng-template #noPhoto>
        {{ item.transactionDesc.charAt(0).toUpperCase() }}
      </ng-template>
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <ng-container *ngIf="commonService.isMobile()">
          <span class="date">{{ item.transactionDate | date : "dd/MM/yyyy" }}</span>
          <span class="title">{{ item.transactionDesc }}</span>
          <span class="description">{{ item.transactionRemarks }}</span>
        </ng-container>

        <ng-container *ngIf="commonService.isDesktop()">
          <div class="sec-1-2">
            <span class="title">{{ item.transactionDesc }}</span>
          </div>
          <box class="desc">
            <box class="sec-2-1">
              <span class="description">{{ item.transactionRemarks }}</span>
            </box>
            <box class="sec-2-2">
              <span class="date">{{ item.transactionDate | date : "dd/MM/yyyy" }}</span>
            </box>
          </box>
        </ng-container>
      </box>
      <box class="trx-secondary-info">
        <ng-container *ngIf="commonService.isMobile()">
          <span class="trx-tag">{{ item.transactionCat }}</span>
          <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
            <span class="debit-sign">-</span>
            <span class="credit-sign">+</span>
            {{item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
              }}</em>
          </span>
        </ng-container>
        <ng-container *ngIf="commonService.isDesktop()">
          <span class="trx-tag">{{ item.transactionCat }}</span>
          <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
            <span class="debit-sign">-</span>
            <span class="credit-sign">+</span>{{
            item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
              }}</em>
          </span>
        </ng-container>
      </box>
    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #creditCardStmtTmplt
  [appControlTemplate]="'recentTransactionsTmplt'">
  <box class="casa-transaction-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="(item.merchantId || item.transactionCat); else noPhoto">
        <img *ngIf="item.icon; else noPhoto" [ngClass]="{'merchant-img': item.merchantId}"
          [src]="'./assets/images/trxicons/'+item.icon">
      </ng-container>
      <ng-template #noPhoto>
        {{ item.transactionDescription?.charAt(0)?.toUpperCase() }}
      </ng-template>
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <ng-container *ngIf="commonService.isMobile()">
          <span class="date">{{ item.transactionDate | dateFormatter : "yyyy-mm-dd" }}</span>
          <span class="title">{{ item.transactionDescription}}</span>
          <span class="description">{{ item.transactionRemarks }}</span>
        </ng-container>
        <ng-container *ngIf="commonService.isDesktop()">
          <div class="sec-1-2">
            <span class="title">{{ item.transactionDescription}}</span>
          </div>
          <box class="desc">
            <box class="sec-2-1">
              <span class="description">{{ item.transactionRemarks }}</span>
            </box>
            <box class="sec-2-2">
              <span class="date">{{ item.transactionDate | date : "dd/MM/yyyy" }}</span>
            </box>
          </box>
        </ng-container>
      </box>
      <box class="trx-secondary-info">
        <ng-container *ngIf="commonService.isMobile()">
          <span class="trx-tag">{{ item.transactionCat }}</span>
          <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
            <span class="debit-sign">-</span>
            <span class="credit-sign">+</span>
            {{item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
              }}</em>
          </span>
        </ng-container>
        <ng-container *ngIf="commonService.isDesktop()">
          <span class="trx-tag">{{ item.transactionCat }}</span>
          <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
            <span class="debit-sign">-</span>
            <span class="credit-sign">+</span>{{
            item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
              }}</em>
          </span>
        </ng-container>
      </box>
    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #loanStmtTmplt
  [appControlTemplate]="'loanstmtTmplt'">

  <box class="loan-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="item.merchantId; else noPhoto">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container>
      <ng-template #noPhoto>
        <i class="icon ico-secure-payment"></i>
      </ng-template>
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <span class="date">{{ item.transactionDate }}</span>
        <span class="title">{{ item.transactionRef }}</span>
        <span class="description">{{ item.narration }}</span>
      </box>
      <box class="trx-secondary-info">
        <span class="trx-tag">{{ item.transactionCategory }}</span>
        <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
          <span class="debit-sign">-</span><span class="credit-sign">+</span>{{
          item.debitAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency }}</em>
        </span>
      </box>
    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #depositStmtTmplt
  [appControlTemplate]="'depositStmtTmplt'">
  <box class="deposit-detail">
    <box class="deposit-logo">
      <img src="./assets/images/icons/deposits.svg" alt="deposit" />
    </box>

    <box class="details">
      <box class="sec-1">
        <ng-container *ngIf="commonService.isMobile()">
          <!-- <div class="sec-1-1"> -->
          <span class="open-date">{{
            item?.openDate | date: "dd/MM/yyyy"
            }}</span>

          <span class="account-name">{{
            item?.depositNickname ? item.depositNickname : item?.accountTypeDesc
            }}</span>
          <!-- </div> -->
        </ng-container>
        <ng-container *ngIf="commonService.isDesktop()">
          <div class="sec-1-2">
            <span class="account-name">{{
              item?.depositNickname
              ? item.depositNickname
              : item?.accountTypeDesc
              }}</span>
            <span class="open-date">{{
              item?.openDate | date: "dd/MM/yyyy"
              }}</span>
          </div>
        </ng-container>
        <box class="months-returns">
          <span class="months">{{ item?.noOfMonthsCompleted }} of
            {{ item?.noOfMonths }} months</span>
          <span class="returns">{{ item?.interestRate }} Return</span>
        </box>
      </box>
      <ng-container *ngIf="commonService.isDesktop()">
        <box class="sec-2 maturity-progress">
          <span class="fill" [style.width.%]="item?.depositState"> &nbsp; </span>
        </box>
      </ng-container>
      <ng-container *ngIf="commonService.isMobile()">
        <box class="sec-2 maturity-progress">
          <span class="fill" [style.width.%]="item?.depositState"> &nbsp; </span>
        </box>
      </ng-container>

      <box class="sec-3">
        <span>Deposit Amount {{item?.depositAmount | currency : item?.currency : '' }} {{item?.currency}}</span>
        <span>Maturity Amount <b>{{item?.maturityAmount | currency : item?.currency : ''}} {{item?.currency}}</b> on
          {{item?.maturityDate | date : "dd/MM/yyyy"}}</span>
      </box>

    </box>

  </box>
</ng-template>

<ng-template #billerCategory [appControlTemplate]="'billerCategory'" let-item let-index="index" let-first="first"
  let-last="last">
  <div class="biller-category-wrapper">
    <img [src]="item.billerLogo" [alt]="item.title">
    <!-- <img  src="./assets/images/icons/broadband.svg" alt="img"> -->
    <span class="biller-category-title">{{item.description}}</span>
  </div>
</ng-template>

<ng-template #billerList [appControlTemplate]="'billerList'" let-item let-index="index" let-first="first"
  let-last="last">

  <div class="biller-item">
    <div class="biller-detail-item">
      <div class="biller-photo">
        <ng-container *ngIf="item?.servicetypes[0].icon; else noPhoto">
          <img *ngIf="item?.servicetypes[0].icon; else noPhoto"
            [src]="'./assets/images/bill-payment/'+ item?.servicetypes[0].icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <span *ngIf="item.name.split(' ').length == 1">{{
              item.name.substring(0, 1)
              }}</span>
            <span *ngIf="
                  item.name.split(' ').length > 1 &&
                  item.name.split(' ').length != 1
                  ">{{
              item.name.split(" ")[0]?.charAt(0) +
              (item.name.split(" ")[1]
              ? item.name.split(" ")[1]?.charAt(0)
              : "")
              }}</span>
          </div>
        </ng-template>
      </div>

      <div class="biller-details">
        <div class="biller-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #upcomingbillerList let-selectedData="selectedData" [appControlTemplate]="'upcomingbillerList'" let-item
  let-index="index" let-first="first" let-last="last">
  <div class="biller-item">
    <div class="biller-detail-item">
      <div class="biller-photo">
        <ng-container *ngIf="item?.serviceTypeId?.icon; else noPhoto">
          <img *ngIf="item?.serviceTypeId?.icon; else noPhoto"
            [src]="'./assets/images/bill-payment/'+ item?.serviceTypeId?.icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <span
              *ngIf="((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(' ').length == 1">{{
              ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.substring(0, 1)
              }}</span>
            <span *ngIf="
                        ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(' ').length > 1 &&
                        ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(' ').length != 1
                  ">{{
              ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(" ")[0]?.charAt(0) +
              (((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(" ")[1]
              ? ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(" ")[1]?.charAt(0)
              : "")
              }}</span>
          </div>
        </ng-template>
      </div>

      <div class="biller-details">
        <div class="biller-date">{{ item?.upcomingbills?.dueDate? 'Due on '+ (item?.upcomingbills?.dueDate.split(' ')[0]
          | date :'dd MMM') : 'No Dues' }}</div>
        <div class="biller-name">{{item?.serviceTypeId?.description}}</div>
        <div class="biller-accountnumner">{{ item?.billerAccountNum }}</div>
      </div>

      <div class="biller-details amount-check-contaioner">
        <div class="check-icon-main" *ngIf="(item?.upcomingbills)">
          <span class="biller-icon" [ngClass]="
                ( selectedData | isRowSelected: index:'index')
                  ? 'biller-selected'
                  : 'biller-unselected'
              ">
            <span class="checkmark"></span>
          </span>


        </div>
        <div *ngIf="(item?.upcomingbills)" class="amount-main"> <span class="biller-amount">{{
            commonService.formatAmount(item.upcomingbills?.dueAmount)}}</span> <span class="currency">{{
            commonService.baseCurrency }}</span>
        </div>
        <!-- <div *ngIf="(item?.upcomingbills | json) == '{}'" class="amount-main"> <span class="biller-amount">No dues</span></div> -->

      </div>
    </div>
  </div>
</ng-template>


<ng-template let-item let-index="index" let-first="first" let-last="last" #paymentHistory
  [appControlTemplate]="'paymentHistory'">
  <box class="payment-history-trx-item">
    <box class="trx-icon">
      <div class="biller-photo">
        <ng-container *ngIf="item.icon; else noPhoto">
          <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/bill-payment/'+item.icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <ng-container *ngIf="item.description; else noName">
              <span *ngIf="item.description?.split(' ').length == 1">{{item.description?.substring(0, 1)}}
              </span>
              <span *ngIf="item.description?.split(' ').length > 1 && item.description?.split(' ').length != 1">
                {{item.description?.split(" ")[0]?.charAt(0) +(item.description?.split(" ")[1]?
                item.description?.split(" ")[1]?.charAt(0): "")}}
              </span>
            </ng-container>
            <ng-template #noName>
              <span> {{ item.description?item.description:'U' }}
              </span>
            </ng-template>

          </div>
        </ng-template>
      </div>
      <!-- {{ item.description?.charAt(0).toUpperCase() }} -->
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <span class="date">{{ item.paymentDate | date :'dd/MM/yyyy' }}</span>
        <span class="title">{{ item.description?item.description:'Unknown' }}</span>
        <span class="description">
          <ng-container *ngIf="item.status; else noStatus">
            <span *ngIf="item.status=='S'" class="success">Successful</span>
            <span *ngIf="item.status=='F'" class="fail">Declined</span>
          </ng-container>
          <ng-template #noStatus>
            <!-- <span class="initiated">Initiated</span> -->
          </ng-template>
        </span>
      </box>
      <box class="trx-secondary-info">
        <div class="arrow-right">
          <img src="./assets/images/icons/arrow-right.svg" alt="icon" />
        </div>
        <span class="payment-amount">
          <span class="amount">
            {{ commonService.formatAmount(item.paymentAmount) }}
          </span>
          <span class="currency">
            {{item.currency}}
          </span>
        </span>

      </box>
    </box>
  </box>
</ng-template>
<!-- scheduledBillList -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #scheduledBillList
  [appControlTemplate]="'scheduledBillList'">
  <box class="scheduled-bill-item">
    <box class="trx-icon">
      <div class="biller-photo">
        <ng-container *ngIf="item.icon; else noPhoto">
          <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/bill-payment/'+item.icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <ng-container *ngIf="item.description; else noName">
              <span *ngIf="item.description?.split(' ').length == 1">{{item.description?.substring(0, 1)}}
              </span>
              <span *ngIf="item.description?.split(' ').length > 1 && item.description?.split(' ').length != 1">
                {{item.description?.split(" ")[0]?.charAt(0) +(item.description?.split(" ")[1]?
                item.description?.split(" ")[1]?.charAt(0): "")}}
              </span>
            </ng-container>
            <ng-template #noName>
              <span> {{ item.description?item.description:'U' }}
              </span>
            </ng-template>

          </div>
        </ng-template>
      </div>
      <!-- {{ item.description?.charAt(0).toUpperCase() }} -->
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <span class="date">Due on {{ item.startDate | date :'dd MMM' }}</span>
        <!-- <span class="date">{{ item.nextPaymentDate | date :'dd/MM/yyyy' }}</span> -->
        <!-- <span class="date">{{ item.endDate | date :'dd/MM/yyyy' }}</span> -->
        <!-- <span class="title">{{ item.description?item.description:'Unknown' }}</span> -->
        <!-- <span class="description">
            <ng-container *ngIf="item.status; else noStatus">
            <span *ngIf="item.status=='S'"class="success" >Successful</span>
            <span *ngIf="item.status=='F'" class="fail">Declined</span>
          </ng-container>
            <ng-template #noStatus>
              <span class="initiated">Initiated</span>
            </ng-template>
          </span> -->
      </box>
      <box class="trx-secondary-info">
        <!-- <span class="trx-tag">{{ item.transactionCat }}</span> -->
        <span class="payment-amount">
          <span class="amount">
            {{ commonService.formatAmount(item.paymentAmount) }}
          </span>
          <span class="currency">
            {{item.currency}}
          </span>
        </span>

      </box>
    </box>
  </box>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #beneTypes [appControlTemplate]="'beneTypes'">
  <div class="bene-types-wrapper">
    <ng-container *ngIf="item.beneRequired==1">
      <div class="bene-types">
        <img class="bene-type-logo" [ngClass]="item.systemCode+'_img'"
          [src]="'./assets/images/transfers/'+item.icon+'.svg'">
        <span class="bene-type-title">{{item.name}}</span>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #newTransfersCategory
  [appControlTemplate]="'newTransfersCategory'">
  <div class="transfer-category-wrapper">

    <ng-container *ngIf="item.enabled == 1">
      <span class="transfer-category-title">{{item.name}}</span>
      <img class="transfer-category-logo" *ngIf="item.icon;" [src]="'./assets/images/transfers/'+item.icon+'.svg'">
    </ng-container>
  </div>
</ng-template>
<!-- recentTransferDisplyGridTmplt -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #recentTransferDisplyGridTmplt
  [appControlTemplate]="'recentTransferDisplyGridTmplt'">
  <box class="transfers-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="item.merchantId; else elseif11">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container>
      <ng-template #elseif11>
        <ng-container *ngIf="item.systemCode == 'INTBT'; else elseif12">
          <img [src]="'./assets/images/transfers/Within Bank Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif12>
        <ng-container *ngIf="item.systemCode == 'SWIFT'; else elseif13">
          <img [src]="'./assets/images/transfers/international-transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif13>
        <ng-container *ngIf="item.systemCode == 'IFSC'; else elseif14">
          <img [src]="'./assets/images/transfers/EFT Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif14>
        <ng-container *ngIf="item.systemCode == 'INTRACSEND'; else elseif15">
          <img [src]="'./assets/images/transfers/Send E-Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif15>
        <ng-container *ngIf="item.systemCode == 'INTRACREQUEST'; else elseif16">
          <img [src]="'./assets/images/transfers/Receive E-Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif16>
        <ng-container *ngIf="item.systemCode == 'OAT'; else noPhoto">
          <img [src]="'./assets/images/transfers/Own Account Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #noPhoto>
        <img [src]="'./assets/images/icons/default-profile-pic.svg'">
        <!-- {{ item.serviceCode?.charAt(0).toUpperCase() }} -->
      </ng-template>
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <span class="date">{{ item.tranDate }}</span>
        <span class="title">{{ item.systemCode=="OAT"?"Own Account":item.beneName }}</span>
        <!-- <span class="description">Credited to:{{item.creditAcc}}</span> -->
        <span class="description">Ref# : {{ item.paymentId }}</span>
      </box>
      <box class="trx-secondary-info">
        <ng-container *ngIf="item.systemCode == 'INTBT'; else elseif1">
          <span class="trx-tag">WITHIN BANK</span>
        </ng-container>
        <ng-template #elseif1>
          <ng-container *ngIf="item.systemCode == 'SWIFT'; else elseif2">
            <span class="trx-tag">INTERNATIONAL</span>
          </ng-container>
        </ng-template>
        <ng-template #elseif2>
          <ng-container *ngIf="item.systemCode == 'IFSC'; else elseif3">
            <span class="trx-tag">BANK TO BANK TRANSFER</span>
          </ng-container>
        </ng-template>
        <ng-template #elseif3>
          <ng-container *ngIf="item.systemCode == 'INTRACSEND'; else elseif4">
            <span class="trx-tag">INTERAC SEND</span>
          </ng-container>
        </ng-template>
        <ng-template #elseif4>
          <ng-container *ngIf="item.systemCode == 'INTRACREQUEST'; else elseif5">
            <span class="trx-tag">INTERAC REQUEST</span>
          </ng-container>
        </ng-template>
        <ng-template #elseif5>
          <ng-container *ngIf="item.systemCode == 'OAT'; else else4">
            <span class="trx-tag">OWN ACCOUNT</span>
          </ng-container>
        </ng-template>
        <span class="amount">
          <span class="debit-sign">-</span>{{
          item.tranAmount | currency : item.tranCurr?.currencyCode : '' }}
          &nbsp;<em>{{item.tranCurr?.currencyCode }}</em>
        </span>
      </box>
    </box>
  </box>

</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #favTransferMiniDisplayGridTmplt
  [appControlTemplate]="'favTransferMiniDisplayGridTmplt'">
  <box class="fav-recent-transfers">
    <box class="prof-image">
      <ng-container>
        <!-- <img  [src]="'./assets/images/icons/default-profile-pic.svg'">
             -->
        {{item.serviceCode == 'OAT'?'OA':commonService.getNameInitial(item.payments?.beneName)}}

      </ng-container>
      <ng-template #noPhoto>
        <!-- {{ item.transactionDescription?.charAt(0)?.toUpperCase() }} -->
        {{item.serviceCode == 'OAT'?'OA':commonService.getNameInitial(item.payments?.beneName)}}

      </ng-template>
    </box>
    <box class="fav-recent-transfer-info">
      <!-- <span class="fav-transfer-value">{{item.serviceCode}}</span> -->
      <ng-container *ngIf="item.serviceCode == 'INTBT'; else elseif1">
        <span class="fav-transfer-value">{{item.payments?.beneName}}</span>
      </ng-container>
      <ng-template #elseif1>
        <ng-container *ngIf="item.serviceCode == 'SWIFT'; else elseif2">
          <span class="fav-transfer-value">{{item.payments?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif2>
        <ng-container *ngIf="item.serviceCode == 'IFSC'; else elseif3">
          <span class="fav-transfer-value">{{item.payments?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif3>
        <ng-container *ngIf="item.serviceCode == 'INTRACSEND'; else elseif4">
          <span class="fav-transfer-value">{{item.payments?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif4>
        <ng-container *ngIf="item.serviceCode == 'INTRACREQUEST'; else elseif5">
          <span class="fav-transfer-value">{{item.payments?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif5>
        <ng-container *ngIf="item.serviceCode == 'OAT'; else else4">
          <span class="fav-transfer-value">Own Account</span>
        </ng-container>
      </ng-template>

      <span class="fav-transfer-amount">{{commonService.formatAmount(item.amount)}} {{item.currency}}</span>
    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #chequeStatusEnquiryResult
  [appControlTemplate]="'chequeStatusEnquiryResult'">
  <ng-container *ngIf="commonService.isDesktop()">
    <box class="trx-item">
      <box class="trx-box">
        <box class="tx-icon">
          <img src="./assets/images/icons/cheque.svg" alt="cheque" />
        </box>
        <box class="trx-primary1-info">
          <span class="customer-name">{{item?.customerName}}</span>
          <span class="cheque-number">{{item?.chequeNumber}}</span>
          <div class="status">{{item?.status}}</div>
        </box>
      </box>
      <!-- <box class="trx-details">
      <span class="issue-date">{{item?.issueDate}}</span>
          <span class="customer-name">{{item?.customerName}}</span>
          <span class="cheque-number">{{item?.chequeNumber}}</span>
          <div class="status">{{item?.status}}</div>
  </box> -->
      <box class="trx-details">
        <box class="trx-secondary1-info">
          <span class="issue-date">{{
            item?.issueDate | date: "dd/MM/yyyy"
            }}</span>
          <span class="amount">{{ item?.amount| currency: item.currency:"" }}&nbsp;<em>{{
              item.currency
              }}</em> </span>
        </box>
      </box>
    </box>
  </ng-container>
  <ng-container *ngIf="commonService.isMobile()">
    <!-- <box class="trx-item">
 <box class="tx-icon">
     <img src="./assets/images/icons/cheque.svg" alt="cheque" />
 </box>
 <box class="trx-details">
     <span class="issue-date">{{item?.issueDate}}</span>
         <span class="customer-name">{{item?.customerName}}</span>
         <span class="cheque-number">{{item?.chequeNumber}}</span>
         <div class="status">{{item?.status}}</div>
 </box>
</box> -->
    <box class="trx-item">
      <box class="trx-box">
        <box class="tx-icon">
          <img src="./assets/images/icons/cheque.svg" alt="cheque" />
        </box>
        <box class="trx-primary1-info">
          <span class="customer-name">{{item?.customerName}}</span>
          <span class="cheque-number">{{item?.chequeNumber}}</span>
          <div class="status">{{item?.status}}</div>
        </box>
      </box>
      <!-- <box class="trx-details">
    <span class="issue-date">{{item?.issueDate}}</span>
        <span class="customer-name">{{item?.customerName}}</span>
        <span class="cheque-number">{{item?.chequeNumber}}</span>
        <div class="status">{{item?.status}}</div>
</box> -->
      <box class="trx-details">
        <box class="trx-secondary1-info">
          <span class="issue-date">{{
            item?.issueDate | date: "dd/MM/yyyy"
            }}</span>
          <span class="amount">{{ item?.amount | currency: item.currency:"" }}&nbsp;<em>{{
              item.currency
              }}</em></span>
        </box>
      </box>
    </box>
  </ng-container>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #allFavTransferDisplayGridTmplt
  [appControlTemplate]="'allFavTransferDisplayGridTmplt'">
  <box class="transfers-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="item.merchantId; else noPhoto">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container>
      <ng-template #noPhoto>
        <!-- <img  [src]="'./assets/images/icons/default-profile-pic.svg'"> -->
        <!-- {{ item.serviceCode?.charAt(0).toUpperCase() }} -->
        {{item.systemCode == 'OAT'?'OA':commonService.getNameInitial(item.payments?.beneName)}}
      </ng-template>
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <span class="date">{{ item.createdOn | date : "dd/MM/yyyy" }}</span>
        <span class="title">{{ item.serviceCode }}</span>
        <!-- <span class="description">Credited to:{{item.accountNumber}}</span> -->
        <span class="description">Ref:{{ item.inventoryNumber }}</span>
      </box>
      <box class="trx-secondary-info">
        <!-- <span class="trx-tag">{{ item.serviceCode }}</span> -->
        <ng-container *ngIf="item.systemCode == 'INTBT'; else elseif1">
          <span class="trx-tag">{{item.payments?.beneName}}</span>
        </ng-container>
        <ng-template #elseif1>
          <ng-container *ngIf="item.systemCode == 'SWIFT'; else elseif2">
            <span class="trx-tag">{{item.payments?.beneName}}</span>
          </ng-container>
        </ng-template>
        <ng-template #elseif2>
          <ng-container *ngIf="item.systemCode == 'IFSC'; else elseif3">
            <span class="trx-tag">{{item.payments?.beneName}}</span>
          </ng-container>
        </ng-template>
        <ng-template #elseif3>
          <ng-container *ngIf="item.systemCode == 'INTRACSEND'; else elseif4">
            <span class="trx-tag">{{item.payments?.beneName}}</span>
          </ng-container>
        </ng-template>
        <ng-template #elseif4>
          <ng-container *ngIf="item.systemCode == 'INTRACREQUEST'; else elseif5">
            <span class="trx-tag">{{item.payments?.beneName}}</span>
          </ng-container>
        </ng-template>
        <ng-template #elseif5>
          <ng-container *ngIf="item.systemCode == 'OAT'; else else4">
            <span class="trx-tag">Own Account</span>
          </ng-container>
        </ng-template>
        <span class="amount">
          <span class="debit-sign">-</span>{{
          item.amount | currency : item.currency : '' }}&nbsp;<em>{{ item.currency }}</em>
        </span>
      </box>
    </box>
  </box>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #beneList [appControlTemplate]="'beneList'">
  <ng-container *ngIf="item?.initial; else noInitial">
    <box>
      {{item?.initial}}
    </box>
  </ng-container>
  <ng-template #noInitial>
    <box class="bene-item">
      <box class="bene-detail-item">
        <box class="bene-detail-list-item">
          <box class="bene-photo">
            <ng-container *ngIf="item.image; else noPhoto">
              <img *ngIf="item.image; else noPhoto" [src]="'./assets/images/bill-payment/'+ item.image" />
            </ng-container>
            <ng-template #noPhoto>
              <box class="bene-letter-name">
                <span>{{ commonService.getNameInitial(item.beneName)}}</span>
                <span *ngIf="item.isFavourite==1" class="fav-star"></span>
              </box>
            </ng-template>
          </box>
          <box class="bene-details">
            <ng-container *ngIf="item.systemCode == 'INTBT'; else elseif1">
              <box class="bene-name">{{item.beneName}}</box>
              <box class="bank-name"></box>
              <box class="acc-number">{{item?.beneinternal?.accountNumber }}</box>
            </ng-container>
            <ng-template #elseif1>
              <ng-container *ngIf="item.systemCode == 'SWIFT'; else elseif2">
                <box class="bene-name">{{item.beneName}}</box>
                <box class="bank-name"></box>
                <box class="acc-number">{{item?.beneswift?.accountNumber }}</box>
              </ng-container>
            </ng-template>
            <ng-template #elseif2>
              <ng-container *ngIf="item.systemCode == 'IFSC'; else elseif3">
                <box class="bene-name">{{item.beneName}}</box>
                <box class="bank-name"></box>
                <box class="acc-number">{{item?.beneifsc?.accountNumber }}</box>
              </ng-container>
            </ng-template>
            <ng-template #elseif3>
              <ng-container *ngIf="item.systemCode == 'INTRAC'; else else1">
                <box class="bene-name">{{item.beneName}}</box>
                <ng-container *ngIf="item?.beneintrac?.mobileNumber; else email">
                  <box class="acc-number">{{item?.beneintrac?.mobileNumber}}</box>
                </ng-container>
                <ng-template #email>
                  <box class="acc-number">{{item?.beneintrac?.email }}</box>
                </ng-template>
              </ng-container>
            </ng-template>
          </box>
        </box>
      </box>
    </box>
  </ng-template>

</ng-template>
<!-- pfmspendcategorydisplaygrid -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #pfmspendcategorydisplaygrid
  [appControlTemplate]="'pfmspendcategorydisplaygrid'">
  <box class="pfm-spend-cat-item">
    <!-- [style.border]="'2px solid'+item?.iconTheme -->
    <box class="pfm-cat-icon" [style.border]="'2px solid'+item?.iconTheme">
      <ng-container *ngIf="item?.icon; else noPhoto">
        <!-- <img  [src]="'./assets/images/'+item.icon+'.svg'"> -->
        <box [innerHTML]="item.icon_svg"></box>
      </ng-container>
      <ng-template #noPhoto>
        <img [src]="'./assets/images/icons/default-profile-pic.svg'">
      </ng-template>
    </box>
    <box class="pfm-spend-cat-details">
      <box class="pfm-spend-cat-primary-info">
        <span class="title">{{ item.description }}</span>
        <span class="amount">
          <!-- [style.color]="item?.iconTheme" -->
          <span class="tranAmount">{{ commonService.formatAmount(item.tranTotal) }}</span>
          <span class="currency"> {{commonService.baseCurrency }}</span>
          ({{pfmMainService.percentCalculate(item.tranTotal)}}% of total exp)
        </span>
        <span class="more-info">
          <span class="description">{{item.record}} Records</span>
          <span class="see-details">See Details</span>
        </span>
      </box>
    </box>
  </box>
</ng-template>
<!-- pfmcategoryhistorydisplaygrid -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #pfmCategoryHistoryDisplayGrid
  [appControlTemplate]="'pfmCategoryHistoryDisplayGrid'">
  <box class="pfm-cat-history-item">
    <box class="pfm-cat-icon">
      <ng-container *ngIf="item?.icon; else noPhoto">
        <img [src]="'./assets/images/'+item.icon+'.svg'" />
      </ng-container>
      <ng-template #noPhoto>
        <img [src]="'./assets/images/icons/default-profile-pic.svg'">
      </ng-template>
    </box>
    <box class="pfm-cat-history-details">
      <box class="pfm-cat-history-primary-info">
        <span class="title">{{ item.tranDesc}}</span>
        <span class="pfm-category">{{ item.inventoryNumber }}</span>
      </box>
      <box class="pfm-cat-history-secondary-info">
        <span class="date">{{ item.paymentDate | date :'dd/MM/yyyy' }}</span>
        <span class="payment-amount">
          <span class="amount">{{ commonService.formatAmount(item.tranAmount) }}
            <span class="currency"> {{item.tranCurrency}}</span>
          </span>

        </span>
      </box>
    </box>
  </box>
</ng-template>


<ng-template #budgetList [appControlTemplate]="'budgetList'" let-item let-index="index" let-first="first"
  let-last="last">

  <div class="budget-item">
    <div class="budget-detail-item">
      <div class="budget-photo">
        <ng-container *ngIf="item?.categoryCode?.icon; else noPhoto">
          <img *ngIf="item?.categoryCode?.icon; else noPhoto"
            [src]="'./assets/images/'+ item?.categoryCode?.icon+'.svg'" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="budget-letter-name">
            <span>{{ commonService.getNameInitial(item.categoryCode.description)}}</span>
          </div>
        </ng-template>
      </div>

      <div class="budget-details">
        <div class="budget-name">{{item.categoryCode?.description}}
        </div>
        <div class="budget-spend-amount">
          <div class="spend-amount">
            {{commonService.baseCurrency}} &nbsp;{{commonService.formatAmount(item.amountSpent)}}
          </div>
          <div class="total-amount">
            {{commonService.baseCurrency}}&nbsp;{{commonService.formatAmount(item.budgetAmount)}}
          </div>
        </div>
        <div class="budget-progress-bar">
          <mat-progress-bar [value]='item.percent'
            [ngClass]="{'primary': (item.percentage >= 0 && item.percentage <= 60), 'warn':(item.percentage>60 && item.percentage<=90),'danger':item.percentage>90 }">
          </mat-progress-bar>
        </div>

        <div class="budget-status">
          <div class="budget-status-name">
            <ng-container *ngIf="(item.percentage >= 0 && item.percentage <= 80); else elseif1">
              On track
            </ng-container>
            <ng-template #elseif1>
              <ng-container *ngIf="(item.percentage>=80 && item.percentage <= 90); else elseif2">
                Almost finish
              </ng-container>
            </ng-template>
            <ng-template #elseif2>
              <ng-container *ngIf="(item.percentage == 100); else elseif3">
                Finish
              </ng-container>
            </ng-template>
            <ng-template #elseif3>
              <ng-container *ngIf="(item.percentage >100 ); else elseif1">
                Exceeding
              </ng-container>
            </ng-template>

          </div>
          <div class="budget-spend-percentage"
            [ngClass]="{'primary': (item.percentage >= 0 && item.percentage <= 60), 'warn':(item.percentage>60 && item.percentage<=90),'danger':item.percentage>90 }">
            {{item?.percentage}} %
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #depositRatesTmplt
  [appControlTemplate]="'depositRatesTmplt'">
  <box class="deposit-rates">
    <box class="rates-sec-1">
      <box class="product-name">
        <span>{{ item.productName }}</span>
      </box>
      <box class="interest-rate">
        <span>{{ item.interestRate }}%</span>
      </box>
    </box>
    <box class="rates-sec-2">
      <box class="tenure">
        <span>{{ item.tenure }} Months</span>
      </box>
      <box class="deposit-amount">
        <span>{{ item.depositAmount | currency: item.currency:"" }}&nbsp;<em>{{
            item.currency
            }}</em>
        </span>
      </box>
    </box>
    <box class="rates-sec-3">
      <span class="deposit-type">{{ item.depositType }}</span>
    </box>
  </box>
</ng-template>
<!-- pfmgoalsdisplaygrid -->
<ng-template #pfmGoalsDisplayGrid [appControlTemplate]="'pfmGoalsDisplayGrid'" let-item let-index="index"
  let-first="first" let-last="last">

  <div class="goals-item">
    <div class="goals-detail-item">
      <div class="goals-photo">
        <ng-container *ngIf="item?.icon; else noPhoto">
          <img [src]="'./assets/images/'+item.icon+'.svg'" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="goals-letter-name">
            <span>{{ commonService.getNameInitial(item.goalName)}}</span>
          </div>
        </ng-template>
      </div>

      <div class="goals-details">
        <div class="goals-name">
          <!-- {{ item.name }} -->
          {{item.goalName}}
        </div>
        <div class="goals-spend-amount">
          <div class="spend-amount">
            {{commonService.baseCurrency}}&nbsp;{{commonService.formatAmount(item.accruedAmount)}}
          </div>
          <div class="total-amount">
            {{commonService.baseCurrency}}&nbsp;{{commonService.formatAmount(item.goalAmount)}}
          </div>
        </div>
        <div class="goals-progress-bar">
          <mat-progress-bar [value]='item.percentage'
            [ngClass]="{'danger': (item.percentage >= 0 && item.percentage <= 25), 'warn':(item.percentage>25 && item.percentage<=75),'primary':item.percentage>75 }">
          </mat-progress-bar>
        </div>

        <div class="goals-status">
          <div class="goals-status-name">
            <ng-container *ngIf="(item.percentage >= 0 && item.percentage <= 25); else elseif1">
              In progress
            </ng-container>
            <ng-template #elseif1>
              <ng-container *ngIf="(item.percentage>25 && item.percentage <= 75); else elseif2">
                On track
              </ng-container>
            </ng-template>
            <ng-template #elseif2>
              <ng-container *ngIf="(item.percentage > 75 && item.percentage < 100); else elseif3">
                Almost finish
              </ng-container>
            </ng-template>
            <ng-template #elseif3>
              <ng-container *ngIf="item.percentage == 100; else else1">
                Completed
              </ng-container>
            </ng-template>
          </div>
          <div class="goals-spend-percentage"
            [ngClass]="{'danger': (item.percentage >= 0 && item.percentage <= 25), 'warn':(item.percentage>25 && item.percentage<=75),'primary':item.percentage>75 }">
            {{item.percentage}} %
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #pfmCategory [appControlTemplate]="'pfmCategory'" let-item let-selectedData="selectedData"
  let-index="index" let-first="first" let-last="last" class="pfm-cat">
  <box class="pfm-category-details">
    <div class="pfm-category">
      <div class="logoWrapper">
        <div class="pfm-category-logo">
          <ng-container>
            <img [src]="'./assets/images/'+item.icon+'.svg'" />
          </ng-container>
        </div>
        <div class="category-name">{{ item.description }}</div>
      </div>
      <div>
        <span class="category-icon" [ngClass]="
              (selectedData | isRowSelected: index:'index')
                ? 'category-selected'
                : 'category-unselected'
            ">
          <span class="checkmark"></span>
        </span>
      </div>
    </div>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #serviceRequestDisplayGrid
  [appControlTemplate]="'serviceRequestDisplayGrid'">
  <div class="service-request-info">
    <div class="service-request-icon-wrapper">
      <img src="./assets/images/icons/cheque.svg" alt="" />
    </div>
    <div class="service-request-details">
      <div class="service-request-detail-row1">
        <span class="date">{{ item.requestDate | date :'dd/MM/yyyy' }}</span>
        <span class="service-request-desc">{{ item.requestTypeDesc }}</span>
        <span class="service-request-number">{{'SERVICEREQUESTLANDING.ref'| translate}} {{
          item.requestReference}}</span>
        <button type="button" class="btn-icon">
          <img src="./assets/images/icons/arrow-right.svg" alt="">
        </button>
      </div>
      <div class="service-request-detail-row2">
        <span [ngClass]="item.customerStatus?.toLowerCase()" class="service-request-status">{{
          item.customerStatus}}</span>
        <span class="amount">{{item.amount}}<em> {{item.currencyCode}}</em></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #serviceRequestStagesDisplayGrid
  [appControlTemplate]="'serviceRequestStagesDisplayGrid'">
  <div class="service-request-status-list-item">
    <div class="service-request-info">
      <div class="service-request-details">
        <div class="service-request-detail-row1">
          <span class="date">{{ item.dateTime }}</span>
          <span class="service-request-desc">{{ item.taskName }}</span>

        </div>
        <div class="service-request-detail-row2">
          <span [ngClass]="item.stage?.toLowerCase()" class="service-request-status">{{ item.stage}}</span>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #bbnSearchResultDisplayGrid
  [appControlTemplate]="'bbnSearchResultDisplayGrid'">
  <div class="bbn-search-result-item">
    <div class="bbn-search-result-details">
      <div class="bbn-search-result-primary-info">
        <div class="profile-details">
          <div class="bbn-profile-icon">
            <img [src]="'./assets/images/sbc/customer-icon.svg'">
          </div>
          <div class="bbn-primary-details">
            <span class="bbn-name">{{item.firstName}}&nbsp;{{item.lastName}}</span>
            <span class="bbn-dob">
              <span class="label">Date: </span>
              <span class="value">{{item.dob | date :'dd MMM YYYY'}}</span>
            </span>
            <span class="bbn-mob-num">
              <span class="label">Mobile No.: </span>
              <span class="value">+63{{item.mobileNumber.substring(1,item.mobileNumber.length)}}</span>
            </span>
          </div>
        </div>
        <div class="preview-button">
          <fpx-button className="preview" btnType="button" label=""></fpx-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #dedupeSearchResultDisplayGrid
  [appControlTemplate]="'dedupeSearchResultDisplayGrid'">
  <div class="dedupe-search-result-item">
    <div class="dedupe-search-result-details">
      <div class="dedupe-search-result-primary-info">
        <div class="profile-details">
          <div class="dedupe-profile-icon">
            <img [src]="'./assets/images/sbc/customer-icon.svg'">
          </div>
          <div class="dedupe-primary-details">
            <span class="dedupe-name">{{item.firstName}}</span>
            <span class="dedupe-dob">
              <span class="label">Date: </span>
              <span class="value">{{item.dateOfBirth | date :'dd MMM YYYY'}}</span>
            </span>
            <span class="dedupe-mob-num">
              <span class="label">Mobile No.: </span>
              <span class="value">+{{item.mobileNumber}}</span>
            </span>
          </div>
        </div>
        <div class="preview-button">
          <fpx-button className="preview" btnType="button" label=""></fpx-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #rmLandingDisplayGrid
 [appControlTemplate]="'rmLandingDisplayGrid'">
 <div class="rm-search-result-item">
  <div class="rm-search-result-details">
   <div class="rm-search-result-primary-info">
    <div class="profile-details">
     <div class="rm-profile-icon-wrapper">
      <div class="rm-profile-icon">
       <img src="./assets/images/sbc/sec-product-icon.svg">
      </div>
      <div class="rm-profile-icon-text">
       <p>Credit Card</p>
      </div>
     </div>

          <div class="rm-primary-details">
            <span class="rm-name">{{item.customerName}}</span>
            <span class="rm-mob-ref">
              <span class="label">Ref :</span>
              <span class="value">{{item.appRef}}</span>
            </span>

            <span class="rm-mob-type">
              <span class="label">Type :</span>
              <span class="value">{{item.applicationType || item.camType}}</span>
            </span>

      <span class="rm-date">
       <span class="label">Date:</span>
       <span class="value" *ngIf="item.createdOn">{{item.createdOn?.split("T")?.[0] | date :'dd MMM YYYY'}} </span>
      </span>
     </div>
    </div>
    <div class="preview-button">
      <fpx-button className="preview" btnType="button"  label="">
        <app-rlo-application-details-display-grid></app-rlo-application-details-display-grid>
      </fpx-button>
    </div>
   </div>

      <div class="rm-chips-sec">

        <div class="tat-sec" *ngIf="item.tatBurstOn">
          <span class="tat">TAT: </span> <span class="tat-days">{{item.tatDays}} days</span>
        </div>
        <div class="tat-category">{{item.stageName}}</div>
      </div>
    </div>
  </div>

</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #rmDetailsDisplayGrid
 [appControlTemplate]="'rmDetailsDisplayGrid'">
 <div class="rm-search-result-item">
  <div class="rm-search-result-details">
   <div class="rm-search-result-primary-info">
    <div class="profile-details">
     <div class="rm-profile-icon-wrapper">
      <div class="rm-profile-icon">
       <img src="./assets/images/sbc/sec-product-icon.svg">
      </div>
      <div class="rm-profile-icon-text">
       <p>Credit Card</p>
      </div>
     </div>

          <div class="rm-primary-details">
            <span class="rm-name">{{item.customerName}}</span>
            <span class="rm-mob-ref">
              <span class="label">Ref :</span>
              <span class="value">{{item.appRef}}</span>
            </span>

            <span class="rm-mob-type">
              <span class="label">Type :</span>
              <span class="value">Regular</span>
            </span>

      <span class="rm-date">
       <span class="label">Date:</span>
       <span class="value">{{item.updatedDt | date :'dd MMM YYYY'}} </span>
      </span>
     </div>
    </div>
    <div class="preview-button">
      <fpx-button className="preview" btnType="button" label=""></fpx-button>
    </div>
   </div>

      <div class="rm-chips-sec">

        <div class="tat-sec" *ngIf="item.tatBurstOn">
          <span class="tat">TAT: </span> <span class="tat-days">{{item.tatDays}} days</span>
        </div>
        <div class="tat-category">{{item.stageName}}</div>
      </div>
    </div>
  </div>

</ng-template>
